import React from 'react'
import styled from '@emotion/styled'

import Img from 'gatsby-image'
import theme from '../../../gatsby-plugin-theme-ui'
import { css } from '@emotion/core'

export const BgImg = styled(Img)`
  position: absolute !important;
  width: 100%;
  height: 100%;
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    z-index: 1;
    ${p =>
      p.withOverlay &&
      css`
        background: rgba(0, 0, 0, 0.4);
      `}
  }
`

export const HeroImage = styled(Img)`
  width: 100%;
  height: 100%;
`

export const HeroImageAspectOvr = styled(Img)`
  width: 100%;
  height: 100%;
  > div:first-of-type {
    padding-bottom: ${props =>
      `${100 / props.sources[0].aspectRatio}% !important`};
    @media (min-width: ${theme.responsive.small}px) {
      padding-bottom: ${props =>
        `${100 / props.sources[1].aspectRatio}% !important`};
    }
  }
`
